module.exports = __webpack_public_path__ + "static/media/2dprbnEs8G8.8b04fe69.jpg";